import Theme from './Theme'
import GlobalStyles from './GlobalStyles'

export default { Theme, GlobalStyles }
